import React, { useContext } from 'react';
import { Typewriter } from 'react-simple-typewriter';
import TypeAnimation from 'react-type-animation';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import bgCover from '../../../images/bgCover.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faDribbbleSquare, faFacebook, faFacebookF, faFacebookSquare, faGithub, faGithubSquare, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import Services from '../Services';
import HomeProjects from '../Home/HomeProjects';
import Contact from '../Contact';
import { DarkModeContext } from '../../../App';
const Banner = () => {
  const [darkMode, setDarkMode] = useContext(DarkModeContext);
  const particlesInit = async (main) => {
    // console.log(main);

    await loadFull(main);
  };

  const particlesLoaded = (container) => {
    // console.log(container);
  };
  return (
    <>
      <div
        className='relative top-20  lg:mx-6 mx-4 bg-primary'
        style={{
          background: `url(${bgCover})`,
          backgroundRepeat: `no-repeat`,
          backgroundSize: `cover`,
          backgroundAttachment: `fixed`,
          borderRadius: `0 0 20px 20px`
        }}
      >
        <Particles className='min-h-screen'
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            fullScreen: { enable: false },
            fpsLimit: 60,
            interactivity: {
              events: {
                onClick: {
                  enable: true,
                  mode: "push",
                },
                onHover: {
                  enable: true,
                  mode: "repulse",
                },
                resize: true,
              },
              modes: {
                push: {
                  quantity: 4,
                },
                repulse: {
                  distance: 100,
                  duration: 0.4,
                },
              },
            },
            particles: {
              color: {
                value: "#78B9C3",
              },

              collisions: {
                enable: true,
              },
              move: {
                direction: "bottom",
                enable: true,
                outModes: {
                  default: "bounce",
                },
                random: false,
                speed: 1,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  area: 800,
                },
                value: 520,
              },
              opacity: {
                value: 0.5,
              },
              shape: {
                type: "star",
              },
              size: {
                value: { min: 1, max: 5 },
              },
            },
            detectRetina: true,
          }}
        />
      </div>
      <div className='grid lg:grid-cols-3 relative lg:-top-[440px] -top-[600px]'>
        <div className={`grid h-[620px] grid-cols-1 w-[300px]  lg:w-[350px] lg:ml-auto lg:top-16 left-8 lg:sticky  card  ${darkMode ?'bg-black/10 glass text-gray-400'  :'bg-white' } shadow-2xl  `}>
          <div className='flex flex-col'>

            <figure class="px-10 pt-10 flex-col">
              <div class="avatar  online">
                <div class="w-28  rounded-full border-4">
                  <img className='' src="https://i.ibb.co/746R1V2/me.jpg" alt='' />
                </div>
              </div>
              <h3 className={`font-bold text-2xl text-primary py-4 ${darkMode && 'text-blue-300'}`}>Nayeem Hasan</h3>

              <div style={{ width: '20em' }} >
                <p className='font-bold text-muted text-sm tracking-wider uppercase pb-8 text-center '>I`M <span><TypeAnimation
                  cursor={true}
                  sequence={[
                    'Front-end Developer',
                    3000,
                    'MERN Stack Developer',
                    3000,
                    'react Developer',
                    3000,
                  ]}
                  wrapper="span"
                  repeat={Infinity}
                /></span> </p>

              </div>
            </figure>

            <div className='text-center z-20 flex border-y-2 border-dotted mx-8 justify-center py-8'>
              <a href="https://www.linkedin.com/in/hasannayeeem/"  target="_blank"><FontAwesomeIcon className='mr-4 hover:text-secondary' icon={faLinkedin}></FontAwesomeIcon></a>
              <a href="https://facebook.com/hasannayeeem"  target="_blank"><FontAwesomeIcon className='mr-4 hover:text-secondary' icon={faFacebookSquare}></FontAwesomeIcon></a>
              <a href="https://github.com/hasannayeeem" target="_blank"><FontAwesomeIcon className='mr-4 hover:text-secondary' icon={faGithubSquare}></FontAwesomeIcon></a>
              <a href="https://nayeemhasan.netlify.app" target="_blank"><FontAwesomeIcon className='mr-4 hover:text-secondary' icon={faDribbbleSquare}></FontAwesomeIcon></a>
            </div>
            <div class="card-body">
              <div className='flex justify-between'><h2 class="font-bold uppercase">country:</h2><h2 class="font-bold uppercase">Bangladesh</h2></div>
              <div className='flex justify-between'><h2 class="font-bold uppercase">city:</h2><h2 class="font-bold uppercase">Sylhet</h2></div>
              <div className='flex justify-between'><h2 class="font-bold uppercase">age:</h2><h2 class="font-bold uppercase">24</h2></div>

              <div class="text-center mt-6 my-auto border-t-2 border-dotted">
                <button class="btn btn-secondary text-white rounded-full px-12 mt-6 text-sm tracking-widest">Contact Me <FontAwesomeIcon className='ml-2' icon={faEnvelope}></FontAwesomeIcon></button>
              </div>
            </div>

          </div>
        </div>
        <div className='grid h-full col-span-2'>
        <div className='lg:w-[765px] lg:ml-8 mx-4 mt-12 lg:glass lg:mr-auto lg:p-8 py-8 rounded-lg'>
            <h1 class="text-4xl font-bold text-green-700 lg:text-green-100">I'm a developer by both passion and profession.</h1>
            <p class="lg:py-6 my-6 py-4 pl-2  font-semibold  text-gray-500 lg:text-green-100 bg-white/10">I am looking for an opportunity to grow my career and to  work with cutting edge technologies.
              I have working experience with Javascript, React, NodeJS (with Express), Bootstrap, Tailwind..etc
              I'm a learning enthusiast, exploring technologies and deep-diving into concepts is one of my hobbies.
              I'm a problem solver, I love to solve problems whenever I face them!</p>
            <button class="z-10 btn lg:btn-primary btn-secondary text-white rounded-full lg:rounded-md mt-1 tracking-widest btn-sm lg:btn-md">hire me</button>
          </div>
                <div className='py-12 lg:px-8 px-6'><Services></Services></div>
                <div><HomeProjects></HomeProjects></div>
                <div><Contact></Contact></div>
                
          </div>
      </div>
    </>

  );
};

export default Banner;